<template>
  <draggable-container>
    <div
      class="modal-content"
      draggable="true"
      :style="`left: ${left}px; top: ${top}px;`"
      @dragend="setPosition($event)"
    >
      <button
        class="calculator-close-button"
        @click="$emit('close')"
      >
        <icon
          name="cross"
          class="calculator-close-icon"
        >
        </icon>
      </button>
      <calculator-engine></calculator-engine>
    </div>
  </draggable-container>
</template>

<script>
import CalculatorEngine from '@/components/calculator/CalculatorEngine.vue';
import DraggableContainer from './DraggableContainer.vue';
import Icon from '@components/singletons/icon.vue';

export default {
  components: {
    CalculatorEngine,
    DraggableContainer,
    Icon,
  },
  data() {
    return {
      left: 100,
      top: 100,
    };
  },
  methods: {
    setPosition(event) {
      this.left = event.clientX;
      this.top = event.clientY;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  position: fixed;
  background: white;
  border: 1px solid black;
  border-radius: 0.25rem;
  box-shadow: 0 0 0.5rem 0.5rem rgba(0, 0, 0, 0.1);
}

.calculator-close-button {
  position: absolute;
  top: -1rem;
  right: -1rem;
  height: 1.5rem;
  width: 1.5rem;
  background: white;
  border: 1px solid black;
  border-radius: 50%;
  cursor: pointer;
}

.calculator-close-icon {
  margin-left: -0.3rem;
  min-width: 1.3rem;
  min-height: 1.3rem;
}

</style>
